<template>
  <Layout footer>

    <div class="app-container app-container_warp text-base">
      <!-- <div class="flex items-center py-5 text-base border-b border-gray-300 pl-3" style="background-color: #faf9f9">
        <span class="mr-1">当前位置：</span>
        <NBreadcrumb>
          <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
          <NBreadcrumbItem>个人中心</NBreadcrumbItem>
        </NBreadcrumb>
      </div> -->
      <div class="flex">
        <div class="left" v-if="0">
          <p class="items-centers_in " style="font-size:26px">导航菜单</p>
          <div class="items-centers_in2">

            <template v-for="(item, index) in tabList" :key="index">
              <div
                v-show="((pops&&(index==9||index==8||index==12))||!pops)&&index!=3&&index!=10&&index!=9&&index!=6&&index!=7"
                class="tab cursor-pointer" :class="{ active: activeTab === index,queren_btn:index==6, }"
                @click="handleClickLeftTab(index)">
                <span class="yuan"></span>
                {{ item }}
              </div>

            </template>
          </div>
        </div>
        <div class="online_left">
          <div class="online_left_title" style="font-size:26px">
            导航菜单
          </div>
          <!-- <div class="online_left_title_line">

          </div> -->
          <template v-for="(item, index) in tabList" :key="index">
            <el-button type="primary" size="large" class="queren_btn" v-if="index==4"
              @click="handleClickLeftTab(index)">
              {{item}}
            </el-button>
            <div class=" online_left_nav" v-else @click="handleClickLeftTab(index)">
              <div class="flex" style="width:100%">
                <!-- <div class="online_left_nav_logo">
                  <el-image
                    :src='`https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/userlogo/ico${(index>7?index-8:index)+1}.png?n=4`'>
                  </el-image>
                </div> -->
                <div class="online_left_nav_text_box" :class="{active:activeTab === index}">
                  <div :class="{queren_btn:index==4}"
                    :style="index==4?'height: 50px;line-height: 50px;width:170px;margin:22px auto;':''">
                    {{item}}
                  </div>
                </div>

              </div>
            </div>
          </template>
          <div style="height:130px">

          </div>
        </div>
        <div class="flex-1">
          <div class="online_right ">
            <div class="online_right_title flex">
              <span class="mr-1" style="color:#333639">所在位置：</span>
              <NBreadcrumb>
                <NBreadcrumbItem style="color:#666" @click="gotoHome">首页</NBreadcrumbItem>
                <NBreadcrumbItem style="color:#666">个人中心</NBreadcrumbItem>
              </NBreadcrumb>
            </div>
            <!--    个人信息      -->
            <Info v-if="activeTab === 0" />
            <!--    个人报告      -->
            <Myreport v-if="activeTab === 1" />
            <!--    投诉与建议      -->
            <Feedback v-if="activeTab === 2" />
            <!--    帮助中心      -->
            <!-- <Helpcenter v-if="activeTab === 3" /> -->
            <!--    服务评价      -->
            <!-- <Serve v-if="activeTab === 3" /> -->
            <!--    技能测评      -->
            <Questionnaire v-if="activeTab === 4" />
            <!--    缴费管理      -->
            <Paythefees v-if="activeTab === 6" />
            <!--    发票管理      -->
            <Invoice v-if="activeTab === 7" />
            <!--    个人设置      -->
            <Settings v-if="activeTab === 3" />
            <Dictation v-if="activeTab === 6" />
          </div>
        </div>
      </div>
    </div>
  </Layout>

  <n-modal v-model:show="showTips" preset="dialog" title="温馨提示" content="是否确认退出系统?" :mask-closable="false"
    positive-text="确认" @positive-click="handleShowTipsConfirm" />
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Layout from '@/components/Layout';
import Info from './components/Info';
import Feedback from './components/Feedback';
import Settings from './components/Settings';
import Serve from './components/Serve';
import Myreport from './components/Myreport';
import Helpcenter from './components/Helpcenter';
import Questionnaire from './components/Questionnaire';
import Paythefees from './components/Paythefees';
import Invoice from './components/Invoice';
import Dictation from '@/views/dictation/index.vue';

const router = useRouter();
const store = useStore();

function gotoHome () {
  router.push('/');
}

const tabList = [
  '个人信息',
  '个人报告',
  '投诉与建议',
  // '帮助中心',
  // '服务评价',
  // '技能测评',
  // '缴费管理',
  // '发票管理',
  '个人设置',
  // '项目路演',
  // '速录考评',
  '退出登录',
];
const pops = store.state.type == 'zj' ? ref(true) : ref(false)
const activeTab = store.state.type == 'zj' ? ref(8) : ref(0);
function handleClickLeftTab (index) {
  if (index === 9) {
    // showTips.value = true;
    router.push('/roadshow');
    return;
  }
  if (index === 10) {
    // router.push('/dictation');
    // return;
  }
  if (index === 4) {
    showTips.value = true;
    return;
  }
  activeTab.value = index;
}

const showTips = ref(false);
function handleShowTipsConfirm () {
  store.dispatch('logout');
  console.log('退出系统');
  // window.location.reload(true);
  router.replace('/');
}
</script>
<style >
.n-input__input-el:disabled {
  color: #000 !important;
}
.n-base-selection-input__content {
  color: #000 !important;
}
</style>
<style lang="scss" scoped>
.queren_btn {
  background-color: #fff;
  border: 1px solid #2d60f6;
  color: #2d60f6;
  border-radius: 40px;
  width: 180px;
  margin: 22px auto;
  margin-left: 39px;
  font-size: 16px;
}
.queren_btn:hover {
  background-color: #2d60f6;
  color: #fff;
}
:deep(.n-breadcrumb-item) {
  font-size: 16px;
}

.left {
  width: 280px;
  margin-right: 60px;
  line-height: 60px;
}

.tab {
  // padding-left: 35px;
  //transition-property: background, color;
  //transition-duration: 0.3s;
  margin-top: 20px;
  transition: all 0.3s ease-in-out;
  width: 300px;
  height: 34px;
  font-size: 16px;
  color: #000;
  line-height: 34px;
  &:hover {
    color: #679cff;
  }
  &.active {
    background-color: #679cff;
    width: 277px;
    height: 34px;
    background: linear-gradient(-90deg, #ffffff, #679cff);
    color: #fff;
  }
  .yuan {
    width: 12px;
    height: 12px;
    background: #fff;
    border-radius: 50%;
    display: inline-block;
    margin: 0 30px 0 15px;
  }
}
.items-centers_in {
  width: 300px;
  height: 40px;
  line-height: 40px;

  background-color: #679cff;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}
.items-centers_in2 {
  border: 1px solid #eee;
  border-top: none;
  box-sizing: border-box;
  padding: 10px 0;
  width: 300px;
}

.online_left {
  width: 258px;
  background: #ffffff;
  border-radius: 20px;
  // margin-right: 29px;
  border-radius: 6px 0 0 6px;
  min-height: 549px;
  box-shadow: 15px -8px 44px 1px rgba(133 133 133 / 19%);
  z-index: 1;
}
.online_left_title {
  height: 79px;
  box-sizing: border-box;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: center;
  padding-top: 30px;
  box-shadow: -16px 10px 22px 0px rgb(133 133 133 / 14%);
  z-index: 10;
  position: relative;
}
.online_left_title_line {
  // width: 324px;
  height: 1px;
  background: #ebebeb;
  margin: 0 auto;
}
.online_left_nav {
  // width: 234px;
  // margin-left: 28px;
  height: 75px;
  font-size: 22px;
  // color: #66a6ff;
  color: #111111;
  display: flex;
  align-items: flex-end;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.online_left_nav_logo {
  width: 45px;
  align-self: flex-end;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-right: 5px;
}
.online_left_nav_text_box {
  // text-align: left;
  // flex: 1;
  // border-bottom: 1px solid #ebebeb;
  // align-self: flex-end;
  // padding-left: 33px;
  // padding-right: 33px;
  height: 75px;
  line-height: 75px;
  // transition: all 1s;
  // border-radius: 15px;

  width: 100%;
  text-align: center;
}
.online_left_nav_text_box.active {
  // background-color: red;
  // background: linear-gradient(0deg, #4e77fc 0%, #3c6fef 51%, #4c6dff 100%);
  // border-radius: 15px;
  color: #2d60f6;
  background-color: rgb(239, 244, 254);
  font-weight: 700;
}
.online_left_nav:hover .online_left_nav_text_box {
  // background-color: red;
  // background: linear-gradient(0deg, #4e77fc 0%, #3c6fef 51%, #4c6dff 100%);
  // border-radius: 15px;
  // color: #2d60f6;
  background-color: rgb(239, 244, 254);
}

.online_right {
  flex: 1;
  background-color: #fff;
  // min-height: 800px;
  border-radius: 0 6px 6px 0;
  color: #666666;
  box-sizing: border-box;
  padding: 10px;
  padding-left: 60px;
  min-height: 649px;
}
.online_right_title {
  height: 79px;
  box-sizing: border-box;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  padding-top: 41px;
}
.n-config-provider {
  background-color: #f4f4f4;
}
</style>
